<form [formGroup]="form" class="grid grid-cols-1 gap-x-6 gap-y-4 mb-4" (ngSubmit)="onSubmit()">
  <div>
    <div class="my-4">
      <label for="password" class="required">Password</label>
      <i
        *ngIf="true"
        nz-popover
        nzPopoverTitle="Password Requirements"
        [nzPopoverContent]="contentTemplate"
        nzPopoverTrigger="hover"
        class="uil uil-info-circle inline-block cursor-pointer p-1 align-middle"
        tabindex="0"
        aria-label="Password requirements">
      </i>

      <div class="flex flex-row items-center">
        <input
          placeholder="Password"
          id="password"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^*()_`~={}[\]:<>?,./])[A-Za-z\d!@#$%^*()_`~={}[\]:<>?,./-]{8,}$"
          type="password"
          [formControl]="password"
          class="w-full px-4 py-2 border border-dark-purple rounded-lg"
          [ngClass]="{ 'border-red': password?.invalid && (password?.dirty || password?.touched) }"
          [maxLength]="50">
      </div>

      @if (password?.touched && password?.invalid && password?.errors?.['required']) {
        <p class="text-sm text-red">This field is required.</p>
      }
      @if (password?.touched && password?.invalid && !password?.errors?.['required']) {
        <p class="text-sm text-red">Password must meet minimum requirements.</p>
      }
    </div>

    <div>
      <label for="confirmPw" class="required">Confirm Password</label>
      <div class="flex flex-row items-center">
        <input
          placeholder="Confirm Password"
          id="confirmPw"
          type="password"
          [formControl]="confirmPw"
          class="w-full px-4 py-2 border border-dark-purple rounded-lg"
          [ngClass]="{ 'border-red': confirmPw?.invalid && (confirmPw?.dirty || confirmPw?.touched) }"
          [maxLength]="50">
      </div>

      @if (confirmPw?.touched && confirmPw?.invalid && confirmPw?.errors?.['required']) {
        <p class="text-sm text-red">This field is required.</p>
      }
      @if (confirmPw?.touched && confirmPw?.invalid && !confirmPw?.errors?.['required']) {
        <p class="text-sm text-red">Password must meet minimum requirements.</p>
      }
      @if (password?.valid && confirmPw?.errors?.['passwordMismatch']) {
        <p class="text-sm text-red">Passwords do not match.</p>
      }
    </div>
  </div>

  <prism-btn btnClass="btn-purple" [disabled]="!form.valid">{{ buttonLabel }}</prism-btn>
</form>

<ng-template #contentTemplate>
  <div class="m-2">
    <p>Passwords must be at least 8 characters in length and contain at least 1 of each of the following character types:</p>
    <ul class="list-disc">
      <li>Lower case letters (a–z)</li>
      <li>Upper case letters (A–Z)</li>
      <li>Numbers (0–9)</li>
      <li>Special Characters (!&#64;#$%^*()_~-=`&#123;&#125;[]:<>?,/.)</li>
      <li>Note: Special characters & and + are not permitted</li>
    </ul>
  </div>
</ng-template>
